<script lang="ts" setup>
const props = defineProps({
  linkTitle: String
})
</script>

<template>
  <nuxt-link class="link">
    {{ props.linkTitle }}
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  display: flex;
  justify-content: center;
  padding: toRem(11) toRem(29);
  border: 1px solid $color-gray-line;
  font-size: toRem(16);
  font-weight: 700;
  color: $color-gray-1;
}
</style>
